import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import common_en from "./translations/en/common.json";
import common_es from "./translations/es/common.json";
import common_de from "./translations/de/common.json";
import common_tr from "./translations/tr/common.json";

// the translations
const resources = {
  es: {
    translation: common_es
  },
  en: {
    translation: common_en
  },
  de: {
    translation: common_de
  },
  tr: {
    translation: common_tr
  }
};


i18n
  // detect user language
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  .init({
    resources,
    fallbackLng: 'es',
    debug: false,

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    }
  });


export default i18n;